<template>
    <DModal
        ref="modal"
        :title="__('settings.translation.import_modal')"
        :show="show"
        @close="$emit('close')"
    >
        <template #default>
            <DCard
                :subtitle="__('settings.translation.import_file_hint')"
                padding
            >
                <DCardBody>
                    <DFileInput
                        :multiple="false"
                        @change="fileChange"
                    />
                </DCardBody>
            </DCard>
            <DCard
                v-if="!_.isEmpty(errors)"
                padding
            >
                <DCardHeader class="text-danger">
                    {{ __('settings.translation.import_errors') }}
                </DCardHeader>
                <DCardBody>
                    <div
                        v-for="error in errors"
                        :key="error"
                        class="text-danger"
                    >
                        {{ error }}
                    </div>
                </DCardBody>
            </DCard>
        </template>
        <template #actions>
            <DButton
                icon="upload"
                :label="__('settings.translation.import')"
                @click="uploadFile"
            />
        </template>
    </DModal>
</template>

<script setup>
import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import _ from 'lodash'

defineProps({
    show: {
        type: Boolean,
        default: false
    },
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    }
})
defineEmits(['close'])
const modal = ref(null)

const form = useForm({
    file: null
})

function fileChange (files) {
    form.file = files[0]
}
function uploadFile () {
    if (form.file !== null && form.isDirty) {
        form.post(route('settings.tenant-translations.import'), {
            onSuccess: function () {
                modal.value.close(true, false)
            }
        })
    }
}
</script>

<style scoped lang="scss">

</style>
